// extracted by mini-css-extract-plugin
export default {"zoomModal":"o2-z","image":"p2-z","button":"q2-z","isOverlayShown":"r2-z"};